import { getApi, postApi } from "../apiCall";

export const getUserDocument = (token) => {
  let url = `${process.env.REACT_APP_API_URL}/view/profile/documents`;
  return getApi(url);
};

export const uploadDocument = ({ type }) => {
  let url = `${process.env.REACT_APP_API_URL}/document/upload/public?type=${type}`;
  return postApi(url);
};

export const get_Document_By_id = ({ type, id }) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/file/url/${id}?isChat=true`;
  return getApi(url);
};

export const get_STOA = ({ type, id }) => {
  let url = `${process.env.REACT_APP_API_URL}/doc/generate/STOA/WORD/BSB/${id}/${type}`;
  return postApi(url, {}, {}, false, "blob");
};
